import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  home;

  constructor() { }

  ngOnInit(): void {
    this.home = localStorage.getItem('home') ? localStorage.getItem('home') : '/login';
  }

}
